export default __webpack_public_path__ + "static/media/ts.c7b1d1bf.jpg";